import { GuardedType, isString } from "generic-type-guard";

import { createDescriptorFunctions } from "@de.skhh.modulf/client-core";

export const InvitationModalDescriptor = createDescriptorFunctions({ modal: "InvitationModal" } as const, {
	applicationKey: isString,
	sourceAppKeys: isString,
	initiatingActivityId: isString
});

export type InvitationModalDescriptor = GuardedType<typeof InvitationModalDescriptor.isInstance>;
